module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp12_7005.0b92b2b1.png";